
import Directory from '../../components/category-item/directory'

const Home = () => {


  return (
   

    <Directory  />

  
  );

};


export default Home;